<template src="./SignIn.html"/>
<style lang="scss" scoped src="./SignIn.scss"/>

<script>

import {SfAlert, SfCheckbox, SfButton, SfInput, SfLoader, SfLink, SfHeading} from '@storefront-ui/vue';
import OrkToggle from "@/components/Ork/OrkToggle";
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";
import OrkPasswordJudge from "@/components/Ork/OrkPasswordJudge.vue";

export default {
  name: "SignIn",
  components: {
    OrkRecaptcha,
    SfCheckbox,
    OrkToggle,
    SfHeading,
    SfAlert,
    SfInput,
    SfButton,
    SfLoader,
    SfLink,
    OrkPasswordJudge
  },
  props: {
    showLogin: {type: Boolean, default: true}

  },
  data() {
    return {
      isSubmitButtonDisabled : true,
      loading: false,
      error: null,
      passwordValid: false,
      createAccount: false,
      submitted: false,
      firstName: "",
      firstNameBlur: true,
      newsLetterSubscribed: false,
      twoFactorAuthenticationEnabled: true,
      lastName: "",
      lastNameBlur: true,
      password: "",
      passwordBlur: true,
      repeatPassword: "",
      repeatPasswordBlur: true,
      email: "",
      emailBlur: true,
      repeatEmail: "",
      repeatEmailBlur: true,
    }
  },
  watch: {
    isLogIn() {
      this.email = ""
      this.repeatEmail = ""
      this.password = ""
      this.createAccount = false
      this.firstName = ""
      this.lastName = ""
    },
  },
  computed: {
    valid() {
      return this.passwordValid && this.password === this.repeatPassword;
    }
  },
  methods: {
    executeRecaptcha() {
      this.$refs.recaptchaSignIn.execute()
    },

    validRepeatPassword(repeatPassword) {
      if (this.password === repeatPassword) {
        return true;
      } else {
        return false
      }
    },

    validRepeatEmail(email, repeatEmail) {
      if (email === repeatEmail) {
        return true;
      } else {
        return false
      }
    },

    validFirstName(firstName) {
      return firstName.length >= 2;
    },

    validLastName(lastName) {
      return lastName.length >= 2;
    },

    validEmail(email) {
      const regex = /(.+)@(.+){2,}\.(.+){2,}/
      const hasWhiteSpace = /\s/;
      if (regex.test(email.toLowerCase()) && !hasWhiteSpace.test(email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },

    onPasswordValid(isPasswordValid) {
      this.passwordValid = isPasswordValid;
    },

    submitSignInForm(token) {
      const onComplete = () => {
        if (!this.error || this.error.status === 200) {
          this.loading = false;
        } else {
          this.loading = false;
        }
      };

      const onError = (e) => {
        this.error = e;
        this.loading = false;
      };
      if (this.valid) {
        this.loading = true;
        this.$emit('submit', {
          form: {
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            twoFactorAuthenticationEnabled: this.twoFactorAuthenticationEnabled,
            newsLetterSubscribed: this.newsLetterSubscribed,
            recaptchaData: token
          }, onComplete, onError
        });
      }
    },
  }
}
</script>


